<template>
  <v-layout
    v-bind="attributes"
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['fab-container', getSelectedDEV && 'dev-selected-component']"
  >
    <v-btn
      fab
      v-for="(action, index) in actions"
      v-bind="action.attributes"
      @click="execute(action)"
      :key="index"
      :name="action.name"
      :id="action.id"
      v-tooltip.left="{ content: action.tooltip, classes: action.tooltipColorClass }"
    >
      <v-icon v-if="action.attributesIcon.icon" v-bind="action.attributesIcon">{{ action.attributesIcon.icon }}</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [devComponentMixin],

  props: {
    actions: { type: Array, required: true },
    mode: { type: String, required: true },
    page: { type: String, required: true },
    step: { type: Number, required: false },
    attributes: { type: Object, default: () => ({}), required: true },
    schema: { type: Object, default: () => ({}) }
  },

  methods: {
    execute(action) {
      action.mode = this.mode;

      this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.page, step: this.step });
    }
  }
};
</script>

<style lang="scss" scoped>
.fab-container {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 5;
}

.v-card__actions .v-btn {
  margin: 6px 8px;
}
</style>
